import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ConfirmationModal } from '../../../components/ConfirmationModal';

interface IPublishDatasetConfirmationModalProps {
  showPublishDatasetConfirmationModal: boolean;
  onDatasetPublishConfirm: () => Promise<void>;
  onPublishDatasetCancel: () => void;
}

export const PublishDatasetConfirmationModal = observer((props: IPublishDatasetConfirmationModalProps): ReactElement => {
  return (
    <ConfirmationModal
      confirmationHeader='publish_dataset_confirmation'
      confirmationQuestion='publish_dataset_confirmation_body'
      confirmationYes={'publish'}
      onCancel={props.onPublishDatasetCancel}
      onConfirm={props.onDatasetPublishConfirm}
      showModal={props.showPublishDatasetConfirmationModal}
      loaderKey='publish'
    />
  );
});
